import React from 'react'
import PropTypes from 'prop-types'
import Image from '../../../helpers/Image/Image'
import { agnostifyUrl } from '../../../helpers/utils'
import { onLinkClickFn } from '../../../helpers/ComponentHelper'
import * as Styled from './M027.styles'

/**
 * M027 is an inspirational promo component that introduces greater height and support for a wider and 1/2 grid layout
 */
const M027 = ({
  heading,
  consumingGridType,
  ctaCopy,
  mainImage,
  linkTarget,
  linkTitle,
  linkUrl,
  secondaryImage,
  onLinkClick
}) => {
  const insideGrid = !!consumingGridType
  if (!secondaryImage && !insideGrid) return null

  return (
    // TODO: DS grid migration
    <Styled.Container data-test='m027-container'>
      <Styled.ImageContainer
        data-test='m027-images-container'
        insideGrid={insideGrid}
        href={agnostifyUrl(linkUrl)}
        target={linkTarget}
        title={linkTitle}
        onClick={(evt) => onLinkClickFn(evt, onLinkClick, linkUrl)}
      >
        <Styled.Images data-test='m027-image-container' className='xs-12--none xs-row'>
          <Styled.ImageWrapper
            data-test='m027-primary-image-container'
            className={`xs-12--none ${insideGrid || !secondaryImage ? '' : 'sm-6--none'}`}
            hasTwoImages={!insideGrid && secondaryImage}
            isSecondaryImage={false}
          >
            <Image data-test='m027-primary-image' alt={mainImage.altText} src={mainImage.source} smart />
          </Styled.ImageWrapper>

          {secondaryImage && !insideGrid && (
            <Styled.ImageWrapper
              data-test='m027-secondary-image-container'
              className='xs-hidden sm-block sm-6--none'
              isSecondaryImage
              hasTwoImages
            >
              <Image data-test='m027-secondary-image' alt={secondaryImage.altText} src={secondaryImage.source} smart />
            </Styled.ImageWrapper>
          )}
        </Styled.Images>
      </Styled.ImageContainer>

      <Styled.Heading data-test='m027-heading'>{heading}</Styled.Heading>
      <Styled.ButtonContainer data-test='m027-cta-container'>
        <Styled.M027Button
          data-test='m027-cta'
          kind='secondary'
          title={linkTitle}
          onClick={() => window.open(agnostifyUrl(linkUrl), linkTarget)}
        >
          {ctaCopy}
        </Styled.M027Button>
      </Styled.ButtonContainer>
    </Styled.Container>
  )
}

M027.propTypes = {
  /** Required copy for the CTA */
  ctaCopy: PropTypes.string.isRequired,
  /** Required text to be displayed as the heading */
  heading: PropTypes.string.isRequired,
  /** Option of opening in a new tab, defaults to an empty string  */
  linkTarget: PropTypes.oneOf(['', '_blank', '_self']),
  /** Required link title, can be seen when hovering over the CTA */
  linkTitle: PropTypes.string.isRequired,
  /** Required link url */
  linkUrl: PropTypes.string.isRequired,
  /** Required image */
  mainImage: PropTypes.shape({
    /** Image source */
    source: PropTypes.string.isRequired,
    /** Alt text for the image */
    altText: PropTypes.string.isRequired
  }).isRequired,
  /** Optional image */
  secondaryImage: PropTypes.shape({
    /** Image Source */
    source: PropTypes.string.isRequired,
    /** Alt text for the image */
    altText: PropTypes.string.isRequired
  })
}

M027.defaultProps = {
  linkTarget: ''
}

export default M027
